/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreExternalCostResponseDto } from '../../models/core-external-cost-response-dto';
import { CoreExternalCostUpdateDto } from '../../models/core-external-cost-update-dto';

export interface ExternalCostsControllerUpdate$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * External cost ID
 */
  id: string;
      body: CoreExternalCostUpdateDto
}

export function externalCostsControllerUpdate(http: HttpClient, rootUrl: string, params: ExternalCostsControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreExternalCostResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, externalCostsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreExternalCostResponseDto>;
    })
  );
}

externalCostsControllerUpdate.PATH = '/o2-core/external-costs/{tenant}/id/{id}';
